const moment = require("moment");
import { WeekPlanApi } from "../api/WeekPlanApi";

export const recurring = {
    data() {
      return {
          weekPlansStatus: []
      }
    },
    methods: {
      loadSkippable() {
        var wm = new WeekPlanApi()
        return wm.available().then(response => {
          let data = response.body.data;

          data = data.map(i => {
              let shipments = [];

              for (let x = 1; x <= 5; x++) {
                let deliveryDay = i['delivery_' + x];
                let date = moment(i.week + " " + i.year, "ww YYYY").startOf("week").add(x , "days").format("YYYY-MM-DD")


                shipments.push({
                  date: date,
                  active: !!i.active && deliveryDay,
                  week: i.week,
                  year: i.year,
                  day: x
                })
              }

            this.weekPlansStatus = this.weekPlansStatus.concat(shipments);

              return shipments
          })
        })
      }
    },
    computed: {
        getSkippableRange() {

            let current = this.$root.user.last_recurring_date

            let start = moment(current)
                .locale("it")
                .startOf("week")
                .add(this.value.day - 1, "days");

            // Not deliverable? Start from current week
            if (moment().startOf("day").diff(moment(start), "days") >= -6) {
                start = moment()
                .locale("it")
                .startOf("week")
                .add(this.value.day - 1, "days");
            }

            let available = [];

            if (!this.shipmentZone) {
                return available;
            }

            for (let i = 0; i < 4; i++) {

                start = moment(start).add(this.value.frequency, "days");

                let active = true;

                let date = this.weekPlansStatus.find(x => {
                  return x.date == start.format("YYYY-MM-DD")
                })

                if (date) {
                   active = date.active
                }

                available.push({
                    shipment: start,
                    delivery: moment(start).add(
                        1 * (this.shipmentZone.attributes.transit_time / 24),
                        "days"
                    ), // check 48 hours
                    skipped:
                        this.value.calendar.indexOf(
                            start.format("YYYY-MM-DD")
                        ) !== -1,
                    active: active
                });
            }

            return available;
        },
    },
};
